module.exports = __webpack_public_path__ + "img/ic_page-right.2b927049.svg";